import { render, staticRenderFns } from "./ProductEditorCards.vue?vue&type=template&id=e1a05754&"
import script from "./ProductEditorCards.vue?vue&type=script&lang=js&"
export * from "./ProductEditorCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports